import {Button, List, ListItem, ListItemIcon, ListItemText,} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import InfoIcon from "@material-ui/icons/Info";
import {isDebug, targetBlank} from "../../utils/commonUtils";
import {
    // cssPaths,
    GWT_GEN2_STRATEGY,
    MARKETING_SITE_KAIZEN_ALZURL,
    MARKETING_SITE_KAIZEN_NLGURL,
    MARKETING_SITE_URL,
    NY_AGENT,
    NationalLifeCarrierDetail,
    GIFTOR_PORTAL,
} from "../../constants";
import * as React from "react";
import HomeIcon from "@material-ui/icons/Home";
import ListAltIcon from "@material-ui/icons/ListAlt";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../reducers";
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import PersonIcon from "@material-ui/icons/Person";
import {useGwtV2} from "../../hooks/isGwtV2";

export default function AgentLinkClient(props: any) {
    const {
        handleNavigation,
        estimationRoute,
        routeName,
        isServiceDashboardAccessible,
        user,
        strategySlug,
        isClientDemoAccess,
        enrollmentTabse,
        handleNavClick,
        enrollmentClick,
        enrollmentStatus,
    } = props;
    const estimationRouteArray: any = [
        "/client/estimation",
        "/client/estimationV1",
    ];
    const history = useHistory();
    // given access to Giftor Portal to all clients from enrollment to servicing except demo mode
    const showParent = user.accessType !== "client";
    const {user: {client}} = useSelector((state: RootState) => state.auth);
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    const strategyId = (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) || (user && user.demoStrategyId);
    const carrierId = (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id) || (user && user.demoCarrierId)
    const isGWTGen2 = strategyId === GWT_GEN2_STRATEGY;
    const isGWTGenV2 = useGwtV2();
    const marketingKaizenURL = carrierId === NationalLifeCarrierDetail.id ? MARKETING_SITE_KAIZEN_NLGURL : MARKETING_SITE_KAIZEN_ALZURL;
    const firstTimeServicingAccess = client && client.serviceLoggedIn;
    const agentLink =
            clientPolicy &&
            clientPolicy.agent &&
            clientPolicy.agent.agentLinks &&
            clientPolicy.agent.agentLinks.length > 0 &&
            clientPolicy.agent.agentLinks[0].guid;
    let educationCenter: any =
            agentLink === "25ab03b1-9308-44d2-bf0c-b57d4c850b81" ||
            agentLink === "5d85c662-f048-481e-a30d-a01a5cfcca2e"
                    ? "https://jared.simplicityniw.com/25ab03b1-9308-44d2-bf0c-b57d4c850b81"
                    : marketingKaizenURL + agentLink;
    //Special Case
    if (NY_AGENT === agentLink) {
        educationCenter = MARKETING_SITE_URL + agentLink;
    }
    const fromLandingPage =
            client && client.fromLandingPage && client.clientPolicies && client.clientPolicies.length > 0 && !client.clientPolicies[0].showMarketing;
    if (fromLandingPage && clientPolicy && clientPolicy.company && clientPolicy.company) {
        educationCenter = `${clientPolicy.company.landingPageVideo}/${clientPolicy.company.companyLinkUrl}`;
    }
    const firstListItems = [
        {
            className: routeName === "/dashboard"
                    ? "active menuHead"
                    : "menuHead",
            onClick: () => {
                handleNavigation("/dashboard");
            },
            icon: <HomeIcon/>,
            isShown: !(
                    user.accessType === "client" || isServiceDashboardAccessible
            ),
            component: <ListItemText primary={"Home Dashboard"}/>,
        },
        {
            className: routeName === `/${GIFTOR_PORTAL}` ? "active menuHead" : "menuHead",
            onClick: () => handleNavigation(`/${GIFTOR_PORTAL}`),
            icon: <PersonIcon/>,
            isShown: (isServiceDashboardAccessible ? !!firstTimeServicingAccess : showParent),
            component:  <ListItemText primary={"Giftor Portal"}/>,
        },
        {
            className: (routeName === '/client/action-items') ? "active menuHead" : "menuHead",
            onClick: () => handleNavigation(`/client/action-items`),
            icon: <ListAltIcon/>,
            isShown: (isServiceDashboardAccessible ? !!firstTimeServicingAccess : true),
            component: <ListItemText primary={"Action Items"}/>,
        },
        {
            className: "menuHead",
            onClick: () => targetBlank(educationCenter),
            icon:  <InfoIcon/>,
            isShown: !isGWTGenV2 && !isServiceDashboardAccessible,
            component: <ListItemText primary="Education Center"/>,
        },
        {
            ListItemProps: {button: true},
            className: estimationRouteArray.includes(routeName)
                    ? "active"
                    : "",
            onClick: () => handleNavigation(estimationRoute),
            icon: <DescriptionIcon/>,
            isShown: !isGWTGenV2 && !isServiceDashboardAccessible,
            component: <ListItemText primary="Estimate My Benefits"/>,
        }
    ]

    const secondListItems = [
        {
            isShown: user.inviteStatus === 10 && strategySlug !== "esd",
            component: <Button
                    className="btnPrimary btnHilight animated-box in"
                    variant="contained"
                    color="primary"
                    disabled={user.accessType === "client"}
            >
                <DescriptionIcon className="mr15"/>
                Enrollment
            </Button>,
        },
        {
            isShown: !(user.inviteStatus === 10 && strategySlug !== "esd") &&  !isServiceDashboardAccessible &&
                    !isClientDemoAccess,
            ListItemProps: {button: true, disabled:user.accessType === "client"},
            className: `menuHead ${enrollmentTabse.indexOf(history.location.pathname) > -1 ? "active" : ""}`,
            icon: <ListAltIcon/>,
            component: <React.Fragment>
                        <ListItemText
                                className={` ${user.accessType === "client" ? "disabled" : ""} `}
                                onClick={() => {
                                    enrollmentClick(user);
                                    handleNavClick();
                                }}
                                primary={
                                    <>
												<span
                                                        style={{
                                                            float: "left",
                                                            marginTop: "6px",
                                                        }}
                                                >
													Enrollment{" "}
												</span>
                                        {user.inviteStatus >= 2 &&
                                                !user.enrollment && (
                                                        <span>
																{enrollmentStatus()}
														</span>
                                                )}
                                    </>
                                }
                        />
                    </React.Fragment>

        },
        {
            className: `menuHead ${isGWTGen2 ? "active" : ""}`,
            onClick: () => {
                history.push(`/${GIFTOR_PORTAL}`);
            },
            icon: <InsertInvitationIcon/>,
            // to hide on servicing
            isShown: !isServiceDashboardAccessible,
            component:  <ListItemText
                    className={`menuHead ${isGWTGen2 ? "active" : ""}`}
                    onClick={() => {
                        history.push(`/${GIFTOR_PORTAL}`);
                    }}
                    primary={
                        <>
                            <div style={{float: "left", marginTop: "6px", width: "100%"}}>
                                Invite Recipient(s)
                                <span className="btnHilightBar floatRight"
                                      style={{color: "#ffffff !important"}}>Invite</span>
                            </div>
                        </>
                    }
            />,
        },



    ]


    return (
            <>
                <List>
                {
                    firstListItems.map((item: any, index: number) => {
                        if(item.isShown){
                            return (
                                    <ListItem
                                            {
                                                ...item.ListItemProps
                                            }
                                            className={item.className}
                                            key={index}
                                            onClick={item.onClick}
                                    >
                                        <ListItemIcon>
                                            {item.icon}
                                        </ListItemIcon>
                                        {item.component}
                                    </ListItem>
                            )
                        }else{
                            return (<></>)
                        }
                    })
                }
                </List>

                <List className="listTwo">
                    {
                        secondListItems.map((item: any, index: number) => {
                            if(item.isShown){
                                return (
                                        <ListItem
                                                {
                                                    ...item.ListItemProps
                                                }
                                                className={item.className}
                                                key={index}
                                                onClick={item.onClick}
                                        >
                                            <ListItemIcon>
                                                {item.icon}
                                            </ListItemIcon>
                                            {item.component}
                                        </ListItem>
                                )
                            }else{
                                return (<></>)
                            }
                        })
                    }
                </List>
            </>
    )
    // @todo remove after testing
    // return (
    //         <>
    //             {
    //                 <>
    //                     <List>
    //                         {!(
    //                                 user.accessType === "client" || isServiceDashboardAccessible
    //                         ) && (
    //                                 <ListItem
    //                                         className={
    //                                             routeName === "/dashboard"
    //                                                     ? "active menuHead"
    //                                                     : "menuHead"
    //                                         }
    //                                         onClick={() => {
    //                                             handleNavigation("/dashboard");
    //                                         }}
    //                                 >
    //                                     <ListItemIcon>
    //                                         <HomeIcon/>
    //                                     </ListItemIcon>
    //                                     <ListItemText primary={"Home Dashboard"}/>
    //                                 </ListItem>
    //                         )}
    //                         {
    //                                 showParent &&
    //                                 <ListItem
    //                                         className={routeName === `/${GIFTOR_PORTAL}` ? "active menuHead" : "menuHead"}
    //                                         onClick={() => handleNavigation(`/${GIFTOR_PORTAL}`)}
    //                                 >
    //                                     <ListItemIcon>
    //                                         <PersonIcon/>
    //                                     </ListItemIcon>
    //                                     <ListItemText primary={"Giftor Portal"}/>
    //                                 </ListItem>
    //                         }
    //                         {
    //                                 <ListItem
    //                                         className={(routeName === '/client/action-items') ? "active menuHead" : "menuHead"}
    //                                         onClick={() => handleNavigation(`/client/action-items`)}
    //                                 >
    //                                     <ListItemIcon>
    //                                         <ListAltIcon/>
    //                                     </ListItemIcon>
    //                                     <ListItemText primary={"Action Items"}/>
    //                                 </ListItem>
    //                         }
    //                         <>
    //                             {/*//COMMENT IN NIWD-380 FOR NOW MAY 22*/}
    //                             {
    //                                     !isGWTGenV2 &&
    //                                     <ListItem
    //                                             className="menuHead"
    //                                             onClick={() => targetBlank(educationCenter)}
    //                                             button
    //                                     >
    //                                         <ListItemIcon>
    //                                             <InfoIcon/>
    //                                         </ListItemIcon>
    //                                         <ListItemText primary="Education Center"/>
    //                                     </ListItem>
    //                             }
    //                             <ListItem
    //                                     button
    //                                     className={
    //                                         estimationRouteArray.includes(routeName)
    //                                                 ? "active"
    //                                                 : ""
    //                                     }
    //                                     onClick={() => handleNavigation(estimationRoute)}
    //                             >
    //                                 <DescriptionIcon/>
    //                                 <ListItemText primary="Estimate My Benefits"/>
    //                             </ListItem>
    //                         </>
    //                     </List>
    //                     <List className="listTwo">
    //                         {user.inviteStatus === 10 && strategySlug !== "esd" ? (
    //                                 <ListItem>
    //                                     <Button
    //                                             className="btnPrimary btnHilight animated-box in"
    //                                             variant="contained"
    //                                             color="primary"
    //                                             disabled={user.accessType === "client"}
    //                                     >
    //                                         <DescriptionIcon className="mr15"/>
    //                                         Enrollment
    //                                     </Button>
    //                                 </ListItem>
    //                         ) : (
    //                                 !isServiceDashboardAccessible &&
    //                                 !isClientDemoAccess && (
    //                                         <React.Fragment>
    //                                             <ListItem
    //                                                     className={`menuHead ${enrollmentTabse.indexOf(history.location.pathname) > -1 ? "active" : ""}`}
    //                                                     button
    //                                                     disabled={user.accessType === "client"}
    //                                             >
    //                                                 <React.Fragment>
    //                                                     <ListAltIcon/>
    //                                                     <ListItemText
    //                                                             className={` ${user.accessType === "client" ? "disabled" : ""} `}
    //                                                             onClick={() => {
    //                                                                 enrollmentClick(user);
    //                                                                 handleNavClick();
    //                                                             }}
    //                                                             primary={
    //                                                                 <>
	// 											<span
    //                                                     style={{
    //                                                         float: "left",
    //                                                         marginTop: "6px",
    //                                                     }}
    //                                             >
	// 												Enrollment{" "}
	// 											</span>
    //                                                                     {user.inviteStatus >= 2 &&
    //                                                                             !user.enrollment && (
    //                                                                                     <span>
	// 															{enrollmentStatus()}
	// 													</span>
    //                                                                             )}
    //                                                                 </>
    //                                                             }
    //                                                     />
    //                                                 </React.Fragment>
    //                                             </ListItem>
    //                                         </React.Fragment>
    //                                 )
    //                         )}
    //
    //                         <ListItem
    //                                 className="menuHead"
    //                                 button
    //                                 disabled={isGWTGen2}
    //                         >
    //                             <React.Fragment>
    //                                 <InsertInvitationIcon/>
    //                                 <ListItemText
    //                                         className={`menuHead ${isGWTGen2 ? "active" : ""}`}
    //                                         onClick={() => {
    //                                             history.push(`/${GIFTOR_PORTAL}`);
    //                                         }}
    //                                         primary={
    //                                             <>
    //                                                 <div style={{float: "left", marginTop: "6px", width: "100%"}}>
    //                                                     Invite Recipient(s)
    //                                                     <span className="btnHilightBar floatRight"
    //                                                           style={{color: "#ffffff !important"}}>Invite</span>
    //                                                 </div>
    //                                             </>
    //                                         }
    //                                 />
    //                             </React.Fragment>
    //                         </ListItem>
    //                     </List>
    //                 </>
    //             }
    //         </>
    // );
}
